import React from 'react';
import { useState } from 'react';
import { customersAPI } from '../../../API/Customers';
import DataTableControl from '../../Common/DataTable';
import { headerData } from '../../Common/DataTable/SampleData';
import Filter from '../../Common/Filters';
import Toaster from '../../Common/Toaster';

export default function Search() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    title: '',
    message: '',
    timeOut: '',
    type: '',
    subTitle: '',
  });
  const [toaster, setToaster] = useState(false);

  const getTableData = async (value) => {
    setLoading(true);
    const param = {
      $page: value?.page,
      $limit: value?.limit,
    };
    const res = await customersAPI?.getCustomerData(param);
    if (res || !res) setLoading(false);
    if (res && res && res?.length > 0 && res[0] === false) {
      error && setToaster(false);
      return res[1];
    } else {
      setToaster(true);
      setError({
        ...error,
        title: 'API Fail',
        message: 'Something went to wrong!',
        type: 'error',
      });
      return [];
    }
  };

  const batchActionClick = (value, actionType) => {
    console.log('value', value);
    console.log('actionType', actionType);
  };

  const handleCloseToaster = () => {
    setToaster(false);
    console.log(`test`);
  };

  return (
    <div>
      <h2>
        <b>Search</b>
      </h2>
      {toaster && (
        <Toaster
          title={error?.title}
          message={error?.message}
          type={error?.type}
          handleCloseToaster={handleCloseToaster}
        />
      )}
      <Filter />
      <DataTableControl
        title=""
        columns={headerData}
        batchActionClick={batchActionClick}
        getData={getTableData}
        isSort
        loading={loading}
      />
    </div>
  );
}
